import { useAppDispatch } from "@/stores/hook";
import { togglePanel } from "../stores/aiChatSlice";
import { useIsAIEnabled } from "../hooks/useIsAIEnabled";

// ---------------------------------------------------------------------------
// Header trigger to open the AI panel. Drop this into the existing header
// near other right-side actions. Hidden entirely if AI is off for the tenant.
// ---------------------------------------------------------------------------

export default function AIToggleButton() {
  const dispatch = useAppDispatch();
  const isAIEnabled = useIsAIEnabled();
  if (!isAIEnabled) return null;

  return (
    <button
      onClick={() => dispatch(togglePanel())}
      title="Open AI assistant (⌘K)"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "6px 10px",
        borderRadius: 8,
        border: "1px solid var(--color-black-3, #e5e7eb)",
        background: "var(--color-bg, #fff)",
        cursor: "pointer",
        fontSize: 12,
        color: "var(--color-text-primary, #1a1a1a)",
      }}
    >
      <span>✨</span>
      <span>Ask AI</span>
      <kbd
        style={{
          fontSize: 10,
          padding: "1px 5px",
          borderRadius: 4,
          background: "var(--color-black-2, #f5f5f5)",
          color: "var(--color-text-secondary, #666)",
          marginLeft: 4,
        }}
      >
        ⌘K
      </kbd>
    </button>
  );
}
